(function () {
  function parseCounterText(text) {
    text = text.trim();

    // Extract leading prefix (non-numeric chars, e.g. "₹")
    var prefixMatch = text.match(/^([^\d]*)/);
    var prefix = prefixMatch ? prefixMatch[1] : '';
    var remaining = text.slice(prefix.length);

    // Extract numeric part (digits, commas, decimal point)
    var numMatch = remaining.match(/^([\d,\.]+)/);
    if (!numMatch) return null;

    var numStr = numMatch[1];
    var cleanNum = numStr.replace(/,/g, '');
    var value = parseFloat(cleanNum);
    if (isNaN(value)) return null;

    var isDecimal = numStr.indexOf('.') !== -1;
    var decimalPlaces = isDecimal ? (numStr.split('.')[1] || '').length : 0;
    var hasComma = numStr.indexOf(',') !== -1;

    var suffix = remaining.slice(numMatch[1].length);

    return { prefix: prefix, value: value, suffix: suffix, isDecimal: isDecimal, decimalPlaces: decimalPlaces, hasComma: hasComma };
  }

  function formatNumber(value, hasComma, isDecimal, decimalPlaces) {
    if (isDecimal) {
      return value.toFixed(decimalPlaces);
    }
    var rounded = Math.round(value);
    if (!hasComma) return String(rounded);

    // Format with commas (handles values up to crores)
    return rounded.toLocaleString('en-IN');
  }

  function animateCounter(el, info, duration) {
    var startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var elapsed = timestamp - startTime;
      var progress = Math.min(elapsed / duration, 1);
      // Cubic ease-out
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = info.value * eased;

      el.textContent = info.prefix + formatNumber(current, info.hasComma, info.isDecimal, info.decimalPlaces) + info.suffix;

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = info.prefix + formatNumber(info.value, info.hasComma, info.isDecimal, info.decimalPlaces) + info.suffix;
      }
    }

    requestAnimationFrame(step);
  }

  function initCounters() {
    var section = document.querySelector('.am-consultation-icons');
    if (!section) return;

    var counterEls = section.querySelectorAll('.am-consultation-icons-text p');
    if (!counterEls.length) return;

    // Collect parsed data upfront so originals are preserved
    var items = [];
    counterEls.forEach(function (el) {
      var info = parseCounterText(el.textContent);
      if (info) items.push({ el: el, info: info });
    });

    if (!items.length) return;

    var animated = false;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !animated) {
          animated = true;
          items.forEach(function (item) {
            animateCounter(item.el, item.info, 1500);
          });
          observer.disconnect();
        }
      });
    }, { threshold: 0.3 });

    observer.observe(section);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCounters);
  } else {
    initCounters();
  }
})();
